import React from 'react';
import PropTypes from 'prop-types';

const ShippingImage = ({staticImagesUrl, daysTo}) => {
   
  let Regular = `${staticImagesUrl}images/svg/delivery-truck-with-tyres.svg`;
  let sameDay = `${staticImagesUrl}images/navigation/level_2/same_day_delivery.svg`;
  
   return (
    <div className="shipping-fees__image hidden-xs">
      <img 
        src={ daysTo === 1 || 0 ? sameDay : Regular}
        width="24"
      />
    </div>
  );
};

ShippingImage.propTypes = {
  staticImagesUrl: PropTypes.string.isRequired,
  daysTo: PropTypes.number.isRequired
};

export default ShippingImage;